import Link from 'next/link';
import { ArrowRightBlackImage } from '../../features/svgImages/ArrowRightBlackImage';

export const TextLinkWithArrow: React.FC<
  {
    href: string;
    text: string;
  } & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className'>
> = ({ href, text, ...props }) => (
  <Link
    {...props}
    href={href}
    className="tw-flex tw-w-fit tw-items-center tw-gap-[0.5rem]"
  >
    <div className="tw-text-base1 tw-underline">{text}</div>
    <ArrowRightBlackImage alt="" className="tw-h-[1rem] tw-w-[1rem]" />
  </Link>
);
